<template>
  <div class="flex flex-shrink-0 overflow-hidden bg-trader-gray dark:rounded p-2">
    <div class="flex justify-center gap-2 ">
      <!--
      <TRSelect class="h-full">
        {{ props.dataLength }}
      </TRSelect>
      -->

      <!-- old replace with TRButton -->
      <!--
      <div class="bg-trader-gray items-center flex w-[25px] justify-center h-[25px]"
           @click="changeCount(PageNavigation.START)">
        <i class="fa-solid fa-backward-step text-[17px]"></i>
      </div>
      <div class="bg-trader-gray items-center flex w-[25px] justify-center h-[25px]"
           @click="changeCount(PageNavigation.MINUS)">
        <i class="fa-solid fa-angle-left text-[17px]"></i>
      </div>
      <div class="bg-trader-gray items-center flex w-[25px] justify-center h-[25px]"
           @click="changeCount(PageNavigation.PLUS)">
        <i class="fa-solid fa-angle-right text-[17px]"></i>
      </div>
      <div class="bg-trader-gray items-center flex w-[25px] justify-center h-[25px]"
           @click="changeCount(PageNavigation.END)">
        <i class="fa-solid fa-forward-step text-[17px]"></i>
      </div>
      -->

      <TRButton class="w-10 flex-shrink-0" @click="changeCount(PageNavigation.START)" icon="fa-solid fa-backward-step">
      </TRButton>

      <TRButton class="w-10 flex-shrink-0" @click="changeCount(PageNavigation.MINUS)" icon="fa-solid fa-angle-left">
      </TRButton>

      <TRButton class="w-10 flex-shrink-0" @click="changeCount(PageNavigation.PLUS)" icon="fa-solid fa-angle-right">
      </TRButton>

      <TRButton class="w-10 flex-shrink-0" @click="changeCount(PageNavigation.END)" icon="fa-solid fa-forward-step">
      </TRButton>


      <div class="text-nowrap items-center flex flex-grow">
        <span>Seite {{ count }}/{{ props.numberOfData }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import TRButton from "@/components/Base/v2/TRButton.vue";
import TRSelect from "@/components/Base/v2/TRSelect.vue";

const PageNavigation = {
  PLUS: 1,
  MINUS: -1,
  START: 0,
  END: 2,
};

const count = ref(1);
const props = defineProps({
  numberOfData: Number,
  onPageStep: Function,
  dataLength: Number,
});

function changeCount(type: number) {
  if (type === PageNavigation.PLUS) {
    if (count.value < props.numberOfData) {
      count.value += 1;
      props.onPageStep(count.value);
    }
  } else if (type === PageNavigation.MINUS) {
    if (count.value > 1) {
      count.value -= 1;
      props.onPageStep(count.value);
    }
  } else if (type === PageNavigation.START) {
    count.value = 1;
    props.onPageStep(count.value);
  } else if (type === PageNavigation.END) {
    count.value = props.numberOfData;
    props.onPageStep(count.value);
  }
}

</script>